module.exports = __webpack_public_path__ + "media/4.f7960371.mp3";